import { CLIENT_TOKEN } from "shadow-client";
import createClient from "../../axios/createClient";

const fetchCounterLineSummary = (badgeNumber, config = {}) => async (dispatch, getState) => {
  const client = createClient(dispatch, getState);

  const url = `/${CLIENT_TOKEN}/counter_lines_summary/${badgeNumber}`;

  const response = await client.request({
    method: "GET",
    url,
    data: {},
    ...config
  });

  return response.data;
};

export default fetchCounterLineSummary;



// WEBPACK FOOTER //
// ./src/shadow-client/endpoints/counterApi/fetchCounterLineSummary.js